const INDICADOR_TIPO = {
    C: { id: 'C', descricao: 'Correção Monetária' },
    J: { id: 'J', descricao: 'Juros' },
    I: { id: 'I', descricao: 'Índice de Mercado' },
    M: { id: 'M', descricao: 'Moeda' },
    T: { id: 'T', descricao: 'Metal' }
};

module.exports = INDICADOR_TIPO;
